export default __webpack_public_path__ + "static/media/list-icon.43a7f9d7.svg";